/**
 * Composable for Google Analytics event tracking
 * Replaces gtag-event mixin for Composition API components
 *
 * @returns {Object} Object with gTagEvent function
 */
export function useGTag() {
  /**
   * Send event to Google Analytics
   * @param {Object} options - Event options
   * @param {string} options.a - Action (default: 'Click')
   * @param {string} options.c - Category
   * @param {string} options.l - Label
   * @param {number} options.v - Value (default: 1)
   */
  const gTagEvent = ({ a = 'Click', c, l, v = 1 } = {}) => {
    if (typeof gtag === 'function') {
      gtag('event', a, {
        event_category: c,
        event_label: l,
        value: v
      })
    }
  }

  return {
    gTagEvent
  }
}
